import React from 'react';
import additional from './safety_color.svg'

const Safety_color = ({ isMobile }) => {
  return (
    <img width={isMobile ? "36" : "56"} height={isMobile ? "36" : "56"} src={additional} />
  )
};

export default Safety_color;
